import React, { useEffect, useState } from 'react';
import axios from 'axios';

function DashboardCard07({ stockSymbol }) {
  const [companyOfficers, setCompanyOfficers] = useState([]);
  const [fullTimeEmployees, setFullTimeEmployees] = useState(null);
  const [currency, setCurrency] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (!stockSymbol) {
        console.error('No stockSymbol provided');
        setLoading(false);
        return;
      }

      try {
        const [companyResponse, financialResponse] = await Promise.all([
          axios.get(`https://investorverden.onrender.com/api/company?q=${stockSymbol}`),
          axios.get(`https://investorverden.onrender.com/api/financials?q=${stockSymbol}`)
        ]);

        console.log('Company API response:', companyResponse.data);
        console.log('Financial API response:', financialResponse.data);

        if (companyResponse.data) {
          if (companyResponse.data.companyOfficers) {
            let officers = companyResponse.data.companyOfficers;

            if (!Array.isArray(officers)) {
              officers = Object.values(officers);
            }

            setCompanyOfficers(officers);
          } else {
            console.error('No company officers found in the response');
            setCompanyOfficers([]);
          }

          setFullTimeEmployees(companyResponse.data.fullTimeEmployees || 'N/A');
        }

        if (financialResponse.data) {
          setCurrency(financialResponse.data.summaryDetail?.currency || financialResponse.data.price?.currency || "USD");
        }

        setLoading(false);
      } catch (error) {
        console.error('Error fetching company data:', error);
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [stockSymbol]);

  if (loading) {
    return <div>Loader...</div>;
  }

  return (
    <div className="col-span-full xl:col-span-12 bg-white dark:bg-gray-800 shadow-sm rounded-xl">
      <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60">
        <h2 className="font-semibold text-gray-800 dark:text-gray-100"> Virksomhedsledelsen</h2>
        <p className="text-gray-600 dark:text-gray-400">Antal fuldtidsansatte: {fullTimeEmployees}</p>
      </header>
      <div className="p-3">
        <div className="overflow-x-auto">
          <table className="table-auto w-full dark:text-gray-300">
            <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-50 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-left">Navn</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Titel</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Alder</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">årsløn</div>
                </th>
              </tr>
            </thead>
            <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
              {companyOfficers.length > 0 ? (
                companyOfficers.map((officer, index) => (
                  <tr key={index}>
                    <td className="p-2">
                      <div className="text-gray-800 dark:text-gray-100">{officer.name || 'N/A'}</div>
                    </td>
                    <td className="p-2">
                      <div className="text-gray-800 dark:text-gray-100">{officer.title || 'N/A'}</div>
                    </td>
                    <td className="p-2">
                      <div className="text-gray-800 dark:text-gray-100">{officer.age || 'N/A'}</div>
                    </td>
                    <td className="p-2">
                      <div className="text-gray-800 dark:text-gray-100">
                        {officer.totalPay ? `${currency} ${officer.totalPay.toLocaleString()}` : 'N/A'}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="p-2 text-center">
                    Ingen virksomhedsledelse fundet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DashboardCard07;